import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, message } from "antd";
import { useIntl } from "react-intl";
import {
  GET_ORGANIZATIONS,
  useOrganizationCreate,
} from "@ticketingplatform/api/dist/organization";
import { ErrorCode } from "@ticketingplatform/api/dist/const/enums/ErrorCode";
import useFormErrors from "hooks/useFormErrors";
import { handleFormErrors } from "utils/handleFormErrors";
import { ROUTE_PATHS } from "const/paths";
import { messagesContent } from "const/messages/formErrors";
import usePrompt from "hooks/usePrompt";

import { OrganizationFormValues } from "../OrganizationForm/types";

import { UseOrganizationAddReturnType } from "./types";
import { initialOrganizationValues } from "./consts";

export const useAddOrganization = (): UseOrganizationAddReturnType => {
  const [form] = Form.useForm();
  const [createOrganization, { loading }] = useOrganizationCreate({
    evictQueries: [GET_ORGANIZATIONS],
  });
  const [initialValues] = useState<OrganizationFormValues>(
    initialOrganizationValues
  );
  const { setApolloError, onValuesChange, showErrorMessage } =
    useFormErrors(form);
  const intl = useIntl();
  const navigate = useNavigate();

  usePrompt(loading);

  const handleSubmit = (values: OrganizationFormValues) => {
    const { name } = values.input;

    return createOrganization({
      variables: { input: { name } },
      onCompleted: async () => {
        message.success(
          intl.formatMessage({
            defaultMessage: "Organization has been added!",
          })
        );

        navigate(ROUTE_PATHS.OrganizationsList, {
          state: {
            skipBlock: true,
          },
        });
      },
      onError: (error) => {
        setApolloError(error);

        const errorMessages = handleFormErrors(error, [
          ErrorCode.INTERNAL_ERROR,
          ErrorCode.ENTITY_EXISTS,
        ]);

        return showErrorMessage(errorMessages, name || "", messagesContent);
      },
    });
  };

  return {
    loading,
    handleSubmit,
    initialValues,
    form,
    onValuesChange: onValuesChange.onFormValuesChange,
  };
};
